var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVscodeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1010px",
    height: "1018px",
    viewBox: "0 0 1010 1018",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M543,781.4 C435.5,673.9 346.8,585.5 346,585.1 C344.9,584.5 311.5,610.4 220.7,682.2 L96.9,780.2 L49.2,755.7 L1.5,731.2 L1,489.5 C0.5,248.5 0.5,247.7 2.5,246.5 C3.6,245.8 25.3,234.6 50.7,221.6 L96.9,197.9 L221.1,296.1 L345.3,394.2 L542.1,197.4 L738.9,0.6 L786.2,19.7 C812.2,30.1 866.4,51.9 906.7,68.1 L979.9,97.5 L980,488.7 C980,858.9 979.9,880 978.2,880.9 C975.4,882.4 740.2,977 739.3,977 C738.9,977 650.5,889 543,781.4 Z M737.3,489.8 C737,379.1 736.8,288.2 736.7,287.7 C736.6,287.3 678.5,332.3 607.7,387.6 C536.9,442.9 479.1,488.7 479.3,489.3 C479.7,490.7 735.2,690.8 736.6,690.9 C737.5,691 737.6,639.3 737.3,489.8 Z M170.4,564.5 C210.9,523.5 244,489.5 244,489 C244,488.3 134.3,374.3 103.9,343.5 L96,335.5 L96,487.3 C96,570.7 96.2,639 96.4,639 C96.6,639 129.9,605.5 170.4,564.5 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "objectBoundingBox",
    x: -15,
    y: -15,
    width: 1009.27778,
    height: 1006.4
  }, /*#__PURE__*/React.createElement("rect", {
    x: -14.2777778,
    y: -14.4,
    width: 1009.27778,
    height: 1006.4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1",
    fill: "black"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(505.000000, 512.500000) scale(-1, 1) rotate(-180.000000) translate(-505.000000, -512.500000) translate(15.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#0060B1",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#FFFFFF",
    mask: "url(#mask-2)",
    strokeWidth: 30,
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M737.3,489.8 C737,379.1 736.8,288.2 736.7,287.7 C736.6,287.3 678.5,332.3 607.7,387.6 C536.9,442.9 479.1,488.7 479.3,489.3 C479.7,490.7 735.2,690.8 736.6,690.9 C737.5,691 737.6,639.3 737.3,489.8 Z",
    id: "Path",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.4,564.5 C210.9,523.5 244,489.5 244,489 C244,488.3 134.3,374.3 103.9,343.5 L96,335.5 L96,487.3 C96,570.7 96.2,639 96.4,639 C96.6,639 129.9,605.5 170.4,564.5 Z",
    id: "Path-Copy",
    fill: "#FFFFFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVscodeLogo);
export default __webpack_public_path__ + "static/media/vscode-logo.766a5760c8b7e3ca573be14154bf9575.svg";
export { ForwardRef as ReactComponent };